import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagHT = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 25 0 25 0s25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M33.696 31.522 25 30.435l-8.696 1.087V18.48h17.392v13.043Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 30.435a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M25 28.26a2.174 2.174 0 1 0 0-4.347 2.174 2.174 0 0 0 0 4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M21.74 20.652h6.52L25 23.913l-3.26-3.26Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M23.913 22.827h2.174v6.521h-2.174v-6.521Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M28.478 28.696h-6.957l-5.217 2.826h17.392l-5.218-2.826Z"
}));
FlagHT.displayName = 'FlagHT';
export default withFlagWrapper(FlagHT);
//# sourceMappingURL=index.js.map